import styled from 'styled-components';
import { PaymentAgreementText } from '@/components/Payment/PaymentAgreementText';
import { profileLayoutDesktopFrameStyles } from '@/features/Profile/core/ProfileLayout/ProfileLayout.styled';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${profileLayoutDesktopFrameStyles}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 0;
    padding: 10px 15px 15px;
    border-radius: 0 0 21px 21px;
  }
`;

export const LoadingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const AgreementText = styled(PaymentAgreementText)`
  margin-top: 20px;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 15px;
    padding: 0;
  }
`;
